export default __webpack_public_path__ + "static/cdp-mobile-ce122b63d834b1e80700725ec74d9894.webp";